import React, { useEffect, useState } from "react";

import { Button } from "semantic-ui-react";

type ShowRequestOAProps = {
  controller: any;
  apiToken: string;
  myDivisions?: any[];
  onBackToMain?: () => void;
};

const IMAGES = {
  userClock: "/static/images/landing/user-clock-outline.png",
};

const ShowRequestOA: React.FC<ShowRequestOAProps> = (props) => {
  const [listPending, setListPending] = useState<string[]>(["MeHealth"]); // Mock data

  useEffect(() => {
    const getPendingList = async () => {
      try {
        const [listDivision, error2, network2] = await props.controller.getListOARequestCheck({
          apiToken: props.apiToken,
        });

        console.log(" listDivision", listDivision, error2, network2);

        if (listDivision?.items?.length > 0) {
          const nameList: string[] = listDivision.items.map(
            (item: any) => JSON.parse(item.division_profile.extra).name
          );

          setListPending(nameList);
        } else if (props.myDivisions && props.myDivisions.length > 1 && props.onBackToMain) {
          props.onBackToMain();
        }
      } catch (error) {
        console.error("Error fetching pending list:", error);
      }
    };

    void getPendingList();
  }, []);

  const handleBackToMain = (): void => {
    if (props.onBackToMain) {
      props.onBackToMain();
    }
  };

  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "calc(100vh - 40px)",
        padding: "2rem",
      }}
    >
      {/* Icon Section */}
      <div
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          marginBottom: "3.5rem",
        }}
      >
        <div style={{ display: "inline-block", position: "relative" }}>
          <img style={{ width: "165px" }} alt="user-clock.icon" src={IMAGES.userClock} />
        </div>
      </div>

      {/* Title Section */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <div
          style={{
            fontSize: "30px",
            fontWeight: "500",
            lineHeight: "1.4",
            marginBottom: "2.25rem",
          }}
        >
          <span>คุณร้องขอเข้าใช้งาน Official Account : </span>
          <span
            style={{ color: "var(--primary-theme-color)", fontWeight: "600", padding: "0 0.5rem" }}
          >
            {listPending.join(", ")}
          </span>
        </div>
      </div>

      {/* Status Message */}
      <div style={{ fontSize: "28px", fontWeight: "400", marginBottom: "6rem" }}>
        {" "}
        กรุณารอการตรวจสอบจากแอดมิน{" "}
      </div>
      {(props.myDivisions ?? []).length > 1 && (
        <Button
          style={{
            background: "var(--primary-theme-color)",
            borderRadius: "8px",
            color: "white",
            fontSize: "16px",
            fontWeight: "500",
            minWidth: "280px",
            padding: "14px 32px",
            transition: "all 0.3s ease",
          }}
          onClick={handleBackToMain}
        >
          กลับสู่หน้าหลัก
        </Button>
      )}
    </div>
  );
};

export default ShowRequestOA;
